/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOXES = gql`
  query GetBoxes($filter: BoxFilterInput, $options: GetManyOptions) {
    getBoxes(filter: $filter, options: $options) {
      content {
        id
        _id
        costumeID
        boxStatus
        paymentStats
        totalAmount
        delegateName
        amountPaid
        totalAmountInUSD
        amountPaidInUSD
        note
        user {
          vuid
          firstName
          lastName
          email
          mailAddress {
            addressLine1
            city
          }
          address {
            addressLine1
            city
          }
        }
        isVIP
        isMagic
        items {
          costumeType {
            name
            description
            images
            id
            minDownPayment
          }
          costumeFeature {
            id
            name
            alias
            isSingleAttribute
            isVisible
            isMandatory
            costumeAttributes {
              id
              name
              isMandatory
              isSingleVal
              isVisible
              costumeValues {
                id
                name
                inventory
                isVisible
                topupPrice
                images
                disclaimer
                isCostumeValueSold
              }
            }
          }
          costumeAttribute {
            id
            name
            isMandatory
            isSingleVal
            isVisible
            costumeValues {
              id
              name
              inventory
              isVisible
              topupPrice
              images
              disclaimer
              isCostumeValueSold
            }
          }
          costumeValue {
            id
            name
            inventory
            isVisible
            topupPrice
            images
            disclaimer
            isCostumeValueSold
            minDownPayment
          }
        }
        presentation {
          id
          name
          status
          country
          year
        }
        section {
          id
          name
        }
        payOrder {
          id
          orderId
          paymentStatus
          updatedAt
          payTxes {
            id
            amount
            mode
            reciptId
            status
            txId
            handler
            errorMessage
            resolutionStatus
            createdAt
            payMethod
          }
        }
        discount {
          lateAssociation
        }
        Referal {
          sectionOptType
        }
        delivery {
          partner
          isOpted
          deliveredTime
          status
          trackingId
        }
        address {
          addressLine1
          city
        }
      }
      count
    }
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
  }
`;
